export default __webpack_public_path__ + "static/media/client4.e955d314.jpeg";